import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [isExpanded, setIsExpanded] = useState(false);
  return <footer className="bg-brand-navy text-white/50 py-12 px-6 text-center text-[10px] space-y-6 relative z-10" data-id="element-64">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-65">
        <p className="leading-relaxed" data-id="element-66">
          Estos son productos y servicios derivados de la vivencia, formación y
          metodología adquirida e implementada por Brenda Hormaechea. No son
          servicios psicológicos, ni financieros. Los resultados que puedas
          obtener dependerán exclusivamente de todas las ganas que pondrás...
        </p>

        <AnimatePresence data-id="element-67">
          {isExpanded && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.4,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-68">
              <p className="leading-relaxed pt-2 text-xs md:text-sm" data-id="element-69">
                ...y de seguir la metodología que te enseñará y con la cual
                miles de alumnas de todo el mundo han conseguido resultados.
                Esto no garantiza resultados para ti, lógicamente cada persona
                es un mundo y debe aplicarlo en sus circunstancias. Tu capacidad
                de aprender, tu disciplina, tu mentalidad, etc., influirán en
                tus resultados y por eso pueden variar. Al realizar la compra de
                la guía “FORMULA CREADORA DE CONTNEIDO DIGITAL UGC” u otro
                programa creado por la marca @entualma.viajes el cliente acepta
                los siguientes términos y condiciones. Mira nuestros términos y
                condiciones para saber más.
              </p>

              <p className="mt-4" data-id="element-70">
                Este sitio no es parte del sitio web de Facebook o Facebook Inc.
                Además, este sitio NO está respaldado por Facebook de ninguna
                manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
              </p>
            </motion.div>}
        </AnimatePresence>

        <button onClick={() => setIsExpanded(!isExpanded)} className="text-white/70 underline font-bold uppercase tracking-widest text-[9px] hover:text-white transition-colors" data-id="element-71">
          {isExpanded ? 'Ver menos' : 'Seguir leyendo'}
        </button>
      </div>

      <div className="pt-6 border-t border-white/10 max-w-4xl mx-auto" data-id="element-72">
        <p className="text-[11px] md:text-sm" data-id="element-73">
          © {new Date().getFullYear()} Brenda Hormaechea. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}